import { useMutation } from '@tanstack/react-query';
import ChessPaymentRestClient from '@/Api/ChessPaymentRestClient';

export interface SelectedSlot {
  date: string;
  time: string;
}

interface CreateRenewalOrderParams {
  tournament_id: number;
  plan_type: 'personal' | 'group' | 'webinar';
  duration_months: number;
  coupon_code?: string;
  selectedSlots?: SelectedSlot[];
  timezone?: string;
  customer_id: number;
  mobile_number: string;
  email: string;
  return_url: string;
  amount?: number; // Grand total amount calculated on frontend
  selected_pricing_id?: number; // Pricing ID from selected pricing entry
}

export default function useCreateRenewalOrder(
  handleOnSuccess?: (data: any) => void,
  handleOnError?: (error: any) => void,
) {
  const mutation = useMutation<any, Error, CreateRenewalOrderParams>(
    async body => {
      // For now, we'll use the existing payment flow
      // The backend will handle renewal-specific logic
      const response = await ChessPaymentRestClient.post(
        'v1/generate_payment_links',
        {
          tournament_id: body.tournament_id,
          customer_id: body.customer_id,
          mobile_number: body.mobile_number,
          email: body.email,
          return_url: body.return_url,
          category_str: `${body.plan_type}_${body.duration_months}months`,
          amount: body.amount, // Send calculated amount from frontend
          renewal_metadata: {
            plan_type: body.plan_type,
            duration_months: body.duration_months,
            coupon_code: body.coupon_code,
            selected_slots: body.selectedSlots || [],
            timezone: body.timezone || 'Asia/Kolkata',
            selected_pricing_id: body.selected_pricing_id,
          },
        },
      );
      return response.data;
    },
    {
      onSuccess: data => {
        if (handleOnSuccess) {
          handleOnSuccess(data);
        }
      },
      onError: error => {
        if (handleOnError) {
          handleOnError(error);
        }
      },
    },
  );

  return {
    ...mutation,
  };
}




